const NAMESPACE = "setIncentiveDesignExpirationDateDialog";

const KEYS = {
    startDateLabel: "startDateLabel",
    noStartDateMessage: "noStartDateMessage",
    expirationDateLabel: "expirationDateLabel",
    expirationDateInfoText: "expirationDateInfoText",
    expirationTodayWarningMessage: "expirationTodayWarningMessage",
    confirmExpirationTodayLabel: "confirmExpirationTodayLabel",
    expirationInPastErrorMessage: "expirationInPastErrorMessage",
    expirationBeforeStartErrorMessage: "expirationBeforeStartErrorMessage",
    expirationInvalidErrorMessage: "expirationInvalidErrorMessage"
};

const MESSAGES = {
    [KEYS.startDateLabel]: {
        value: "Start Date:",
        comment: "Label for the Start Date display in the Set Expiration Date dialog."
    },
    [KEYS.noStartDateMessage]: {
        value: "(no Start Date specified)",
        comment: "Text to display if no Start Date has been specified."
    },
    [KEYS.expirationDateLabel]: {
        value: "Select the date this incentive becomes unavailable in incentive selectors:",
        comment: "Label for the Expiration Date input in the Set Expiration Date dialog"
    },
    [KEYS.expirationDateInfoText]: {
        value: "Dates earlier than Today cannot be selected.  Leave the input blank to remove the Expiration Date.",
        comment:
            "Text in the Set Expiration Date dialog providing additional information about the Expiration Date input"
    },
    [KEYS.expirationTodayWarningMessage]: {
        value:
            "You are setting the expiration date of this Incentive Design to TODAY." +
            " This will expire the Incentive Design immediately and cannot be undone.",
        comment: "Warning message if the Expiration Date is being set to Today."
    },
    [KEYS.confirmExpirationTodayLabel]: {
        value: "Check this box to proceed with immediately expiring this Incentive Design",
        comment: "Label for checkbox used to confirm setting the Expiration Date to Today."
    },
    [KEYS.expirationInPastErrorMessage]: {
        value: "The expiration date cannot be set to a date in the past.",
        comment: "Error message if the Expiration Date is being set to a past date."
    },
    [KEYS.expirationBeforeStartErrorMessage]: {
        value: "The expiration date must be set to a date after the start date.",
        comment: "Error message if the Expiration Date is not after the Start Date."
    },
    [KEYS.expirationInvalidErrorMessage]: {
        value: "The expiration date input is not in a valid format.",
        comment: "Error message if the Expiration Date is not in a valid format."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
